import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnTO: CultureInfo = {
  name: 'en-TO',
  displayName: 'English (Tonga)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-TO',
  parent: CultureInfoEn
};
